<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
  <!-- <app-loader [showLoader]=showLoad></app-loader> -->
  <div class="cards-holder devices-tab">
    <div class="card card2 mRight">
      <app-datatable-v3 [sectiontitle]="sectiontitle" [datatableconfig]="devicedatatableconfig" [key]="key"></app-datatable-v3>
    </div>
    <div class="card card1 mLeft devices-placement-carousel">
      <div class="c-portlet__header">
        <div class="o-stack__cell">
          <h5>
            Screenshots
          </h5>
          <div>Showing Screenshot {{activeIndex+1}}/{{screenShotsData.length}}</div>
        </div>
      </div>
      <div class="screenshot-carousel">
        <div class="selected-image-container">
          <div class="selected-image" [ngStyle]="{'background-image': 'url('+previewData.imageURL+')'}" (click)="previewScreenShotInNewTab(previewData.imageURL)">
          </div>
        </div>
        <div class="screenshot-container">
          <div *ngFor="let screenshot of screenShotsData; let index =index" class="screenshot-details" (click)="previewScreenshot(screenshot, index)" [ngClass]="{'active': index === activeIndex}">
            <span class="screenshot-title">{{screenshot.url}}</span>
            <span class="screenshot-date">{{screenshot.date}}</span>
          </div>
        </div>
        <div class="no-data-container" *ngIf="!hasData">
          <div class="map-no-data">No Data to Display</div>
        </div>
      </div>
    </div>
  </div>
</div>
